module.exports = __webpack_public_path__ + "img/42.10.pH.7de2fadc.png";